import { io } from 'socket.io-client';
import { getToken } from '../config/AxiosInstance';

const token = getToken();
const URL = process.env.REACT_APP_SOCKET_URL;

const socket = io(URL, {
    auth: {
        token
    }
});

export { socket };